import { useEffect } from 'react';
import editorEvent, { EditorEventName, type EditorEventType } from '@/editor/event/editorEvent';
import { useEditor } from './useEditor';
import { EFloorPlanEventName, TFloorPlanEvent } from '@/editor/manager/entityManager/floorPlanManager';

const useEditorEvent = <K extends keyof EditorEventType>(eventName: K, callback: EditorEventType[K]) => {
  useEffect(() => editorEvent.on(eventName, callback), [eventName, callback]);
};

const useFloorPlanManagerEvent = <K extends keyof TFloorPlanEvent>(eventName: K, callback: TFloorPlanEvent[K]) => {
  const editor = useEditor();

  useEffect(() => editor.modelManager.floorPlanManager.addListener(eventName, callback), [editor, eventName, callback]);
};

export {
  useEditorEvent,
  useFloorPlanManagerEvent,
  EditorEventName as EEditorEvent,
  EFloorPlanEventName as EFloorPlanEvent
};
